import { makeWordPressAjaxRequest } from "./ajax";
import { documentStore, globalStore, uiStore } from "@/store/store";
import { exportTree } from "../tree/tree";
import * as t from "io-ts";
import { Either, fold, right, left } from "fp-ts/lib/Either";
import { _Error, logErrorsToUiStore } from "./data";
import { pipe } from "fp-ts/lib/function";
import { fpJsonStringify } from "@/util/fp-json-stringify";
import { breakdanceUndo } from "@/lib/undo/undo";

export async function saveToWordPressWithErrorsLoggedToUiStore(): Promise<
  Either<_Error[], unknown>
> {
  return pipe(
    await makeWordPressAjaxRequest({
      friendlyName: "Saving to WordPress",
      action: "breakdance_save",
      dataToPost: {
        id: documentStore.document.documentMeta.id,
        tree: fpJsonStringify(exportTree(documentStore.document.tree)),
        globalSettings: fpJsonStringify(globalStore.globalSettings),
        classes: fpJsonStringify(globalStore.cssSelectors)
      },
      decoder: t.unknown
    }),
    fold(
      (errors: _Error[]) => {
        logErrorsToUiStore(errors);
        return left(errors);
      },
      r => {
        uiStore.setUnsavedChangesPresent(false);
        breakdanceUndo.ignore(() => {
          globalStore.markCurrentGlobalSettingsAsUntouched();
          globalStore.markCurrentSelectorsAsUntouched();
        });
        return right(r);
      }
    )
  );
}
